import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Mail } from 'lucide-react';
import BackButton from '@/components/BackButton';

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <BackButton />
      <div className="container mx-auto px-6">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Contact Us</h1>
          
          <div className="grid gap-8 mb-12">
            <div className="flex items-start gap-4 p-4 rounded-lg border bg-card">
              <Mail className="w-6 h-6 text-primary" />
              <div>
                <h2 className="font-semibold mb-1">Email Support</h2>
                <p className="text-sm text-muted-foreground mb-2">
                  For general inquiries and support
                </p>
                <a 
                  href="mailto:support@nexuscipherguard.com"
                  className="text-primary hover:underline"
                >
                  support@nexuscipherguard.in
                </a>
              </div>
            </div>
          </div>

          <div className="border rounded-lg p-6 bg-card">
            <h2 className="text-xl font-semibold mb-4">Send us a message</h2>
            <form 
              className="space-y-4"
              name="contact"
              method="POST"
              data-netlify="true"
              netlify-honeypot="bot-field"
            >
              <input type="hidden" name="form-name" value="contact" />
              <p className="hidden">
                <label>
                  Don't fill this out if you're human: <input name="bot-field" />
                </label>
              </p>
              
              <div className="grid gap-4 sm:grid-cols-2">
                <div>
                  <label className="text-sm font-medium mb-1 block">Name</label>
                  <Input name="name" placeholder="Your name" required />
                </div>
                <div>
                  <label className="text-sm font-medium mb-1 block">Email</label>
                  <Input name="email" type="email" placeholder="your@email.com" required />
                </div>
              </div>
              
              <div>
                <label className="text-sm font-medium mb-1 block">Subject</label>
                <Input name="subject" placeholder="How can we help?" required />
              </div>
              
              <div>
                <label className="text-sm font-medium mb-1 block">Message</label>
                <Textarea 
                  name="message"
                  placeholder="Tell us more about your inquiry..." 
                  className="min-h-[120px]"
                  required
                />
              </div>

              <Button type="submit" className="w-full">
                Send Message
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;